import React, { useState, useEffect } from "react";
import "../Pages/CSS/scrolldown.css";

function GlobalCursorFollower() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div>
      <div
        className="outer-cursor"
        style={{
          transform: `translate(${mousePosition.x - 50}px, ${mousePosition.y - 20}px)`,
        }}
      />
      <div
        className="inner-cursor"
        style={{
          transform: `translate(${mousePosition.x - 34}px, ${mousePosition.y - 4}px)`,
        }}
      />
    </div>
  );
}

export default GlobalCursorFollower;
